export const SET_DIGITAL_SERVICE_COMMENT_QUESTION1 = 'SET_DIGITAL_SERVICE_COMMENT_QUESTION1';
export const SET_DIGITAL_SERVICE_COMMENT_QUESTION2 = 'SET_DIGITAL_SERVICE_COMMENT_QUESTION2';

export const setDigitalServiceCommentQuestion1 = (comment) => ({
    type: SET_DIGITAL_SERVICE_COMMENT_QUESTION1,
    payload: comment,
});

export const setDigitalServiceCommentQuestion2 = (comment) => ({
    type: SET_DIGITAL_SERVICE_COMMENT_QUESTION2,
    payload: comment,
});
